import { pair } from './index.js';
/**
 * Two duplex streams that are attached to each other
 */
export function duplexPair() {
    const a = pair();
    const b = pair();
    return [
        {
            source: a.source,
            sink: b.sink
        },
        {
            source: b.source,
            sink: a.sink
        }
    ];
}
